import DepsService from 'services/dependencies';

const CONTEXT = 'selfRegistration';

export const fetchOwnerValidationMethod = (retailerType, outletTypeId, locale = '*') => {
  const { url } = DepsService.rest.dictionary.ownerValidationMethod;
  const queryParams = { retailerType, outletTypeId, locale };
  const urlParams = {};

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const validateOwnerData = (params) => {
  const { url } = DepsService.rest.selfRegistration.validateOwner;
  const queryParams = { ...params };
  const urlParams = {};

  return DepsService.restSrv.create(CONTEXT, url, queryParams, urlParams);
};

export const validateProspectiveData = (pin, captchaToken) => {
  const { url } = DepsService.rest.selfRegistration.validateProspective;
  const queryParams = { pin };
  const urlParams = { captchaToken };

  return DepsService.restSrv.create(CONTEXT, url, queryParams, urlParams);
};

export const fetchOwnerData = (ownerUrlParams, captchaToken) => {
  const { url } = DepsService.rest.selfRegistration.owner;
  const queryParams = { ownerUrlParams, captchaToken };
  const urlParams = {};

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const fetchRetailerDetails = (retailerId, captchaToken) => {
  const { url } = DepsService.rest.user.retailerSettings.selfRegistration;
  const queryParams = { captchaToken };
  const urlParams = { retailerId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const createAccount = (queryParams, urlParams) => {
  const { url } = DepsService.rest.account.primaryEntries;

  return DepsService.restSrv.create(CONTEXT, url, queryParams, urlParams);
};

const transformUserData = ({
  firstName,
  lastName,
  contactPhone,
  mobilePhone,
  emailAddress,
  password,
  businessPhone,
  questionA,
  answerA,
  questionB,
  answerB,
}) => ({
  firstName,
  lastName,
  contactPhone,
  mobilePhone,
  emailAddress,
  password,
  businessPhone,
  challenges: [
    {
      questionId: questionA,
      answer: answerA,
    },
    {
      questionId: questionB,
      answer: answerB,
    },
  ],
});

export const confirmRegistration = async (userData) => {
  const { url } = DepsService.rest.account.confirmRegistration;
  const data = transformUserData(userData);

  return DepsService.restSrv.update(CONTEXT, url, data);
};

export const activateAccount = async (token) => {
  const { url } = DepsService.rest.selfRegistration.activation;
  const queryParams = {
  };
  const urlParams = {
    token
  };

  return DepsService.restSrv.create(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/registration/resources/registration.api.js